import {
  DYNAMIC_DIALOG_INJECT_SYMBOL,
  DynamicDialogs,
} from './dynamicDialog.ts';
import { App, ref, UnwrapRef } from 'vue';

export const DynamicDialogPlugin = {
  install(app: App) {
    const dynamicDialogs = ref<UnwrapRef<DynamicDialogs>>({
      activeDialogs: [],
    });

    app.provide(DYNAMIC_DIALOG_INJECT_SYMBOL, dynamicDialogs);
  },
};
